module.exports = __webpack_public_path__ + "static/assets/7fcd003c4a63163684ba889c2030b9ad.png";